import { jsxs, jsx } from "react/jsx-runtime";
const IconDisallowSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1ZM3 12c0-4.963 4.037-9 9-9a8.95 8.95 0 0 1 5.611 1.975L4.975 17.61A8.951 8.951 0 0 1 3 12Zm9 9a8.951 8.951 0 0 1-5.611-1.975L19.025 6.39A8.951 8.951 0 0 1 21 12c0 4.963-4.037 9-9 9Z" })
    ]
  }
);
export {
  IconDisallowSvg
};
